<template>
  <section class="app-main">
    <breadcrumb class="breadcrumb-container" />
    <back-to-top />
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BackToTop from '../../../components/BackToTop.vue'
import Breadcrumb from '../../../components/Breadcrumb.vue'

export default {
  name: 'AppMain',
  components: {
    Breadcrumb,
    BackToTop,
  },
  computed: {
    ...mapGetters({
      cachedViews: 'app/cachedViews',
    }),
    key() {
      return this.$route.fullPath
    },
  },
}
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  margin-bottom: 100px;
  .breadcrumb-container {
    width: calc(100% - 40px);
    margin: auto 20px;
    border-bottom: $border-base;
  }
}
</style>
